module.exports = __webpack_public_path__ + "static/media/showers-2.17bfcaea.jpg";